import { Input as ExoInput } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects Swedish default aria labels for the clear/dismiss/
// password-toggle controls (ExoKit's Input is i18n-agnostic).
export const Input = (props: ComponentProps<typeof ExoInput>) => {
	const { t } = useTranslation();
	return (
		<ExoInput
			clearAriaLabel={t("Clear")}
			dismissErrorAriaLabel={t("Dismiss error")}
			showPasswordAriaLabel={t("Show password")}
			hidePasswordAriaLabel={t("Hide password")}
			{...props}
		/>
	);
};
